/**
 * @method: to call reducer
 */
import { actionType } from "../connectint/action";
import defaultState from '../../store/defaultStore';
let defaultStore = defaultState;
const reducer = (state = defaultStore, action) => {

      switch (action.type) {
            case actionType.GET_QA_PAGE_DATA_REQUEST:
                  state = { ...state, ...defaultState };
                  break;
            case actionType.GET_QA_PAGE_DATA_RECEIVED:
                  defaultState.connectint.pageData = action.payload;
                  state = { ...state, ...defaultState }
                 
                  break;
            case actionType.QUESTION_LIST_REQUEST:
                  state = { ...state, ...defaultState.connectint };
                  break;
            case actionType.QUESTION_LIST_SUCCESS:
                  defaultState.connectint.QuestionList = action.payload;
                  state = { ...state, ...defaultState.connectint }
                  break;
            case actionType.QUESTION_LIST_FAILURE:
               
                  defaultState.connectint.QuestionList = action.payload;
                  state = { ...state, ...defaultState.connectint }                 
                  break;

            default:
                  state = { ...state };
                  break;
      }

      return state;
};
export default reducer;